<template lang="pug">
.briq-form-element.mb-S
  label(v-if="label") {{ label }}
  briq-required-and-optional-markers(:isRequired="this.$attrs.required" :isDisabled="this.$attrs.disabled || this.$attrs.readonly" :hideOptionalMarker="hideOptionalMarker" :label="label")
  .description(v-if="description") {{ description }}
  .radiobuttons(:class="radiobuttonsClasses")
    .option(v-for="([key, value]) in Object.entries(options)" :key="key")
      label.container.type-standard(:for="name+key" :ref="name+key" :class="labelClasses(key)") {{ value }} 
        .radio-description(v-if="optionsDescription[key]") {{ optionsDescription[key] }}
        input(
          type="radio" 
          disabled="disabled" 
          :name="label" 
          :id="name+key" 
          :value="key" 
          v-model="picked" 
          :disabled="optionIsDisabled(key)"
          :data-test-id="toKebabDataTestId(name+key)"
          )
        span(:class="`radio radio-${radioButtonStyle}`")
</template>

<script>
// todo: make it work with options as an array
// that would complicate things for the template
// keys would be array indices as strings, which is not nice - so the todo is think of a smart solution
import toKebab from '@/helpers/toKebab.js'

export default {
  name: 'BriqRadio',
  props: {
    label: String,
    name: { type: String, default: '' },
    description: String,
    options: Object,
    disabledOptions: { type: Object, default: null },
    optionsDescription: { required: false, default: () => ({}) },
    radioButtonStyle: { required: false, default: 'blue' },
    hideOptionalMarker: { type: Boolean, default: false },
    value: String,
    horizontal: Boolean,
  },
  data() {
    return {
      picked: this.value,
    }
  },
  computed: {
    radiobuttonsClasses() {
      return [
        this.$attrs.disabled ? 'disabled' : '',
        this.$attrs.dense ? 'dense' : '',
        this.$attrs.border ? 'border' : '',
        this.horizontal ? 'horizontal' : '',
      ]
    },
  },
  methods: {
    toKebabDataTestId(val) {
      return toKebab(val)
    },
    optionIsDisabled(key) {
      return (
        this.$attrs.disabled ||
        (this.disabledOptions !== null && this.disabledOptions[key] === true)
      )
    },
    labelClasses(key) {
      return this.optionIsDisabled(key) ? 'disabled-option' : ''
    },
  },
  watch: {
    picked(newVal) {
      this.$emit('input', newVal)
    },
    value(newVal) {
      this.picked = newVal
    },
  },
}
</script>

<style scoped lang="stylus">
.option
  padding 10px 0 6px

  .disabled-option
    opacity 0.4
    cursor default

    > input
      cursor default

.dense
  .option
    padding 1px 0 3px

.option > label
  margin-bottom 0
  font-weight normal

.option > input, .option > label
  cursor pointer

.description
  color #465366
  margin-bottom 10px

.radio-description
  color #96999D
  font-size 12px
  margin-top 5px

.container
  display block
  position relative
  padding 0 0 0 28px
  margin-bottom 11px
  line-height 17px

  input[type='radio']
    position absolute
    top 0
    left 0
    opacity 0
    width 0
    height 0

  .radio
    position absolute
    top 0px
    left 1px
    width 18px
    height 18px
    border 1px solid #aaa
    background white
    border-radius 50%

  input:checked ~ .radio-blue
    border 1px solid #009BFF

  input:checked ~ .radio-grey
    border 1px solid #4E5A6A

  .radio:after
    display none
    content ''

  input:checked ~ .radio:after
    display block

  .radio-blue:after
    width 12px
    height 12px
    background #009BFF
    position absolute
    top 2px
    left 2px
    border-radius 50%

  .radio-grey:after
    content ''
    width 18px
    height 18px
    background #4E5A6A
    background-image url("/images/checked_white.svg")
    background-repeat no-repeat
    background-position center
    background-size 50%
    position absolute
    top -1px
    left -1px
    border-radius 50%

.border
  border 1px solid #eee
  border-radius 4px
  padding 12px

.radiobuttons.disabled
  background #eee

  label
    cursor not-allowed

  input ~ .radio
    border 1px solid #eee

  input ~ .radio:after
    background #eee

.radiobuttons.horizontal
  display flex

  .option
    margin-right 12px
</style>
